import MaintenancePage from "../MaintenancePage";
import costCenterResource from "../../resources/costCenterResource";

export default function CostCenters() {
    return <MaintenancePage resource={costCenterResource} />;
}
